import { Avatar, Button, constants, Text } from '@redbubble/design-system';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import { ArtistShopData } from 'pages/shop/types';
import styles from './ArtistDetails.module.scss';

export const messages = defineMessages({
  viewShop: { defaultMessage: 'View shop' },
});

export interface ArtistDetailsProps
  extends Pick<
    ArtistShopData,
    'shopDisplayName' | 'additionalInfo' | 'avatar'
  > {
  shopUrl: string;
}

export const ArtistDetails: React.FC<ArtistDetailsProps> = ({
  shopDisplayName,
  shopUrl,
  additionalInfo,
  avatar,
}) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <Avatar src={avatar} alt={shopDisplayName} size={constants.MEDIUM} />
      <div>
        <Text display="block" element="p" type="display5">
          {shopDisplayName}
        </Text>
        <Text
          display="block"
          element="p"
          muted
          type="body2"
          className={styles.subtitle}
        >
          {additionalInfo}
        </Text>
      </div>

      <Button href={shopUrl} size={constants.SMALL} strong>
        {intl.formatMessage(messages.viewShop)}
      </Button>
    </div>
  );
};
